import {React, Component, Link, Route, _} from 'utils';
import {App, Creators} from 'model';
import { FastApplyButton } from 'components';
import './activejobs.less';

function fastApplyClicked(event) {
	var jobId = $(event.target).closest('.fast-apply').data('id');
	Creators.jobFastApplyClicked(jobId);
}

function fastApplyClickedJob(event) {
	var jobId = $(event.target).closest('.job-box').data('id');
	Creators.jobFastApplyClicked(jobId);
}

export function JobCard({data, baseUrl, isFairActive})
{
	if (!data.remoteId){
		//return null;
	}

	var src = data.stand.imageUrl;

	var checkboxClass = (data.selected) ? 'fa-check-square' : 'fa-square-o';
	var fastApplySelected = (data.selected) ? 'selected' : '';

	let fastApplyText = _('Fast apply');
	let fastApplyAppliedClass = '';
	if (data.applied)
	{
		fastApplyText = _('Fast applied');
		fastApplyAppliedClass = ' applied ';
	}

	var fastApplySelectedJobBox = (data.selected) ? 'selected-job-box' : '';

	let displayFastApplyButton = (data.remoteId && data.fastApplyEnabled && isFairActive);
	let fastApplyClass = (displayFastApplyButton) ? 'has-fast-apply' : '';

	return <div className={"col-md-3 " + fastApplyClass}>
		<div className= {"job-box " + fastApplySelectedJobBox}>
			<div className="card">
				<div className="card-header">
					<div><img className="mw-100 company-logo" src={src} /></div>
				</div>
				<div className="card-body">
					<div className="job-card-details">
						<h5 className="card-title">{ data.title }</h5>
						<div className="card-text">
							<div><i className="fa fa-map-marker"></i> {(data.locationDisplay && data.locationDisplay.length > 0) ? data.locationDisplay : data.location}</div>
							<div><i className="fa fa-clock-o"></i> { App.formatShortDate(data.deadline) }</div>
						</div>
					</div>
				</div>
			</div>
			<Link to={ baseUrl + data.id }></Link>
			{(displayFastApplyButton) ? (
				<div className={"fast-apply " + fastApplySelected + fastApplyAppliedClass} data-id={data.id} onClick={fastApplyClicked}>
					<div>{fastApplyText}<i className={"fa " + checkboxClass}></i></div>
				</div>
			) : null}
		</div>
	</div>;
}

export function ActiveJobs({data, baseUrl, isFairActive})
{
	if(data && data.length > 0) {

		data.sort((a, b) => {
			let countA = a.stand.standType.standFeatureCount;
			let countB = b.stand.standType.standFeatureCount;
			let desc = 1;
			let ret = 0
			if (countA > countB)
				ret = -1;
			if (countA < countB)
				ret = 1;
			ret = ret * desc;
			return ret;
		})

		var jobs = data.map((item) => {
			return <JobCard key={item.id} data={item} baseUrl={baseUrl} isFairActive={isFairActive}/>
		});

		return (
			<div className="active-jobs">
				<div className="row">{ jobs }</div>
				<FastApplyButton/>
			</div>
		);
	} else {
		return null;
	}

}



// WEBPACK FOOTER //
// ./src/modules/components/activejobs.js